import {reqWithToken} from './requestHelper';

export async function getCoursesTimeOfPE(){
    return (await reqWithToken('api/pebooking/courseTimes')).data;
}

export async function getPeriods(){
    return (await reqWithToken('api/pebooking/periods')).data;
}

export async function submitNormalForm(formData){
    return (await reqWithToken('api/pebooking/booking', {
        method: 'post',
        data : formData
    })).data;
}

export async function submitSuperForm(formData){
    return (await reqWithToken('api/pebooking/booking/super', {
        method: 'post',
        data : formData
    })).data;
}

export async function submitDrawableForm(formData){
    return (await reqWithToken('api/pebooking/booking/drawable', {
        method: 'post',
        data : formData
    })).data;
}

export async function getAvailablePeriods(params){
    return (await reqWithToken('api/pebooking/periods/available',{
        params
    })).data;
}

export async function getAvailablePeriodsSuper(params){
    return (await reqWithToken('api/pebooking/periods/available/super',{
        params
    })).data;
}

export async function getEvents(roomId){
    return (await reqWithToken('api/pebooking/events',{
        params: {roomId}
    })).data;
}

export async function getAvailableOfDrawable(params){
    return (await reqWithToken('api/pebooking/periods/availableOfDrawable',{
        params
    })).data;
}

export async function getEventsOfDrew({roomId, month}){
    return (await reqWithToken('api/pebooking/events/ofDrew',{
        params: {roomId, month}
    })).data;
}

